import React, {useContext, useEffect, useState, useMemo} from 'react';
import {Context} from '../../../Helpers/Auth';
import {useHistory} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import i18n from '../../../i18n';
import Spinner from '../../../components/Spinner';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import {
    getClientes,
    getClientesFiltros,
    getClientesPesquisa,
    getDespesas,
    getDespesasFiltros,
    getDespesasPesquisa,
    getStatus,
    getUtilizadores,
    GetTipoDespesaMoedas,
    getRepresentantes,
    getPaises,
    getLinguas,
    getMoedas,
} from '../../../pages/requests';

import DrawerFilter from '../DrawerFilter';
import TablePagination from '../../TablePagination';
import InputFilter from '../../Filters/InputFilter';
import NotFound from '../../NotFound';
import SelectFilter from '../../Selects/SelectComponentFilt';
import LoadingModal from '../../LoadingModal';
import {Alert} from '@mui/material';
import MultiSelect from '../../Selects/MultiSelect';
import Datepicker from 'react-tailwindcss-datepicker';
import {Collapse, initTE} from 'tw-elements';

function Table({
    onRowClick,
    setEditDespesa,
    filtroCodigo,
    setFiltroCodigo,
    filtroUtilizador,
    setFiltroUtilizador,
    filtroData,
    setFiltroData,
    filtroNome,
    setFiltroNome,
    filtroValor,
    setFiltroValor,
    filtroDespesa,
    setFiltroDespesa,
    filtroEstado,
    setFiltroEstado,
    utilizadores,
    estados,
    tipoDespesas,
}) {
    //const history = useHistory();
    const {t} = useTranslation();
    const [visitas, setVisitas] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [sorting, setSorting] = useState({field: '', order: ''});
    const [currentPage, setCurrentPage] = useState(1);
    const {acessos, isCard, utilizador, openCards, formatarNumero} = useContext(Context);

    const [paises, setPaises] = useState([]);
    const [linguas, setLinguas] = useState([]);
    const [moedas, setMoedas] = useState([]);
    const [totalProdutos, setTotalProdutos] = useState(0);
    const [semDados, setSemDados] = useState(false);
    const [semDadosArray, setSemDadosArray] = useState(false);
    const [utilizadorEscolhido, setUtilizadorEscolhido] = useState('');
    // const [utilizadores, setUtilizadores] = useState([]);
    const [categoria, setCategoria] = useState('');
    const [acessoR, setAcessoR] = useState([]);

    // const [estados, setEstados] = useState([]);
    const [estadoEscolhido, setEstadoEscolhido] = useState([]);
    const [estadoFiltro, setEstadoFiltro] = useState(false);
    const [despesas, setDespesas] = useState([]);
    const [visibilidade, setVisibilidade] = useState(true);
    const [visibilidade2, setVisibilidade2] = useState(true);
    const [search, setSearch] = useState('');
    const [filterP, setFilterP] = useState('');
    const [semDadosEstado, setSemDadosEstado] = useState(false);
    // const [tipoDespesas, setTipoDespesas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(false);
    const handleResize = () => {
        setIsMobile(window.innerWidth < 800);
    };

    initTE({Collapse});

    // //FILTROS TABELA

    // const [filtroCodigo, setFiltroCodigo] = useState('');
    // const [filtroUtilizador, setFiltroUtilizador] = useState([]);
    // const [filtroData, setFiltroData] = useState({
    //     startDate: '',
    //     endDate: '',
    // });
    // const [filtroNome, setFiltroNome] = useState('');
    // const [filtroValor, setFiltroValor] = useState(0);
    // const [filtroDespesa, setFiltroDespesa] = useState('');
    // const [filtroEstado, setFiltroEstado] = useState();
    // const handleRowClick = dados => {
    //     setEditDespesa(true);
    //     onRowClick(dados);
    // };

    const handleRowClick = dados => {
        setEditDespesa(true);
        onRowClick(dados);
    };

    const ITEMS_PER_PAGE = 15;

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    function HandleSpinner() {
        {
            <Spinner />;
        }
    }

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    useEffect(() => {
        acessos.forEach(element => {
            if (element.funcao == 'GESYDESPESA') {
                const acesso = {
                    funcao: element.funcao,
                    consultar: element.consultar,
                    apagar: element.apagar,
                    modificar: element.modificar,
                    criar: element.criar,
                };
                setAcessoR(acesso);
            }
        });
    }, [acessos]);

    useEffect(() => {
        if (!utilizador) {
            return;
        }

        getPaises(lang).then(res => {
            setPaises(res.data.paises);
        });
        getLinguas(lang).then(res => {
            setLinguas(res.data.linguas);
        });
        getMoedas(lang).then(res => {
            setMoedas(res.data.moedas);
        });

        const getData = () => {
            HandleSpinner();
            setDespesas([]);
            getDespesas(utilizador, 0, 14, lang, filtroCodigo, filtroUtilizador, filtroData.startDate ?? '', filtroNome, filtroValor, filtroDespesa.id ?? '', filtroEstado?.value ?? 0)
                .then(res => {
                    HandleSpinner();
                    if (res.data.totalprodutos == '0') {
                        setSemDadosEstado(true);
                    }
                    setDespesas(res.data.despesas);
                    setTotalProdutos(res.data.totalprodutos);
                })
                .finally(() => {
                    setLoading(false);
                });
        };
        getData();
    }, [utilizador, filtroCodigo, filtroUtilizador, filtroData.startDate, filtroNome, filtroValor, filtroDespesa, filtroDespesa, filtroEstado]);

    useEffect(() => {
        if (!utilizador || lang == '') {
            return;
        }

        window.scrollTo(0, 0);
        if (currentPage == 1 && search == '' /*&& paisRecebido == ""*/ && utilizadorEscolhido == '' && estadoEscolhido == '') {
            setVisibilidade2(true);
            //
            getDespesas(utilizador, 0, 14, lang, filtroCodigo, filtroUtilizador, filtroData.startDate ?? '', filtroNome, filtroValor, filtroDespesa.id ?? '', filtroEstado?.value ?? 0)
                .then(res => {
                    if (res.data.totalprodutos == '0') {
                        setSemDadosEstado(true);
                        setVisibilidade2(false);
                    }
                    setDespesas(res.data.despesas);
                    setTotalProdutos(res.data.totalprodutos);
                })
                .finally(() => {
                    setLoading(false);
                });
        } else if (currentPage != 1 && search == '' /*&& paisRecebido == ""*/ && utilizadorEscolhido == '' && estadoEscolhido == '') {
            setVisibilidade2(true);
            const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
            const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
            getDespesas(
                utilizador,
                indexOfFirstItem,
                indexOfLastItem - 1,
                lang,
                filtroCodigo,
                filtroUtilizador,
                filtroData.startDate ?? '',
                filtroNome,
                filtroValor,
                filtroDespesa.id ?? '',
                filtroEstado?.value ?? 0,
            )
                .then(res => {
                    if (res.data.totalprodutos == '0') {
                        setSemDadosEstado(true);
                        setVisibilidade2(false);
                    }
                    setDespesas(res.data.despesas);
                })
                .finally(() => {
                    setLoading(false);
                });
        } else if (currentPage != 1 && search != '' && search.length >= 3 /*&& paisRecebido == ""*/ && utilizadorEscolhido == '' && estadoEscolhido == '') {
            const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
            if (indexOfLastItem > parseInt(totalProdutos)) {
                setVisibilidade2(true);
                const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
                getDespesasPesquisa(utilizador, search, indexOfFirstItem, parseInt(totalProdutos), lang).then(res => {
                    if (res.data.totalprodutos == '0') {
                        setSemDadosEstado(true);
                        setVisibilidade2(false);
                    }
                    setTotalProdutos(res.data.totalprodutos);
                });
            } else {
                setVisibilidade2(true);
                const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
                const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
                getDespesasPesquisa(utilizador, search, indexOfFirstItem, indexOfLastItem - 1, lang).then(res => {
                    if (res.data.totalprodutos == '0') {
                        setSemDadosEstado(true);
                    }
                    setTotalProdutos(res.data.totalprodutos);
                });
            }
        } else if (currentPage == 1 && search != '' && search.length >= 3 /*&& paisRecebido == ""*/ && utilizadorEscolhido == '' && estadoEscolhido == '') {
            setVisibilidade2(true);
            getDespesasPesquisa(utilizador, search, 0, 14, lang).then(res => {
                setTotalProdutos(res.data.totalprodutos);
                if (res.data.totalprodutos == '0') {
                    setVisibilidade2(false);
                    setSemDados(true);
                    setTotalProdutos(1);
                }
            });
        } else if ((currentPage == 1 && utilizadorEscolhido != '' && search == '') || (currentPage == 1 && estadoEscolhido != '' && search == '')) {
            setVisibilidade2(true);

            let utilizadorF;
            let estadoF;
            if (utilizadorEscolhido == '') {
                utilizadorF = '';
            } else {
                utilizadorF = utilizadorEscolhido.value;
            }
            if (estadoEscolhido == '') {
                estadoF = '';
            } else {
                estadoF = estadoEscolhido.value;
            }

            getDespesasFiltros(utilizador, utilizadorF, estadoF, 0, 14, lang).then(res => {
                HandleSpinner();
                // setDespesas(res.data.despesas);
                setTotalProdutos(res.data.totalprodutos);
            });
        } else if ((currentPage != 1 && utilizadorEscolhido != '') || (currentPage != 1 && estadoEscolhido != '')) {
            const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
            if (indexOfLastItem > parseInt(totalProdutos)) {
                setVisibilidade2(true);
                const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;

                let utilizadorF;
                let estadoF;
                if (utilizadorEscolhido == '') {
                    utilizadorF = '';
                } else {
                    utilizadorF = utilizadorEscolhido.value;
                }
                if (estadoEscolhido == '') {
                    estadoF = '';
                } else {
                    estadoF = estadoEscolhido.value;
                }

                getDespesasFiltros(utilizador, utilizadorF, estadoF, indexOfFirstItem, parseInt(totalProdutos), lang).then(res => {
                    if (res.data.totalprodutos == '0') {
                        setSemDadosEstado(true);
                        setVisibilidade2(false);
                    }
                    // setDespesas(res.data.despesas);
                    setTotalProdutos(res.data.totalprodutos);
                });
            } else {
                setVisibilidade2(true);
                const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
                const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;

                let utilizadorF;
                let estadoF;
                if (utilizadorEscolhido == '') {
                    utilizadorF = '';
                } else {
                    utilizadorF = utilizadorEscolhido.value;
                }
                if (estadoEscolhido == '') {
                    estadoF = '';
                } else {
                    estadoF = estadoEscolhido.value;
                }

                getDespesasFiltros(utilizador, utilizadorF, estadoF, indexOfFirstItem, indexOfLastItem - 1, lang).then(res => {
                    setTotalProdutos(res.data.totalprodutos);
                    if (res.data.totalprodutos == '0') {
                        setVisibilidade2(false);
                        setSemDados(true);
                        setTotalProdutos(1);
                    }
                });
            }
        }
    }, [currentPage, utilizador]);

    useEffect(() => {
        setLoading(true);
        if (!utilizador) {
            return;
        }
        if (search.length == 0 /*&& paisRecebido == ""*/) {
            setVisibilidade2(true);

            getDespesas(utilizador, 0, 14, lang, filtroCodigo, filtroUtilizador, filtroData.startDate ?? '', filtroNome, filtroValor, filtroDespesa.id ?? '', filtroEstado?.value ?? 0).then(res => {
                if (res.data.totalprodutos == '0') {
                    setSemDadosEstado(true);
                    setVisibilidade2(false);
                }
                setCurrentPage(1);
                setDespesas(res.data.despesas);
                setTotalProdutos(res.data.totalprodutos);
            });
        } else if (search.length >= 3) {
            setUtilizadorEscolhido('');
            setVisibilidade2(true);
            getDespesasPesquisa(utilizador, search, 0, 14, lang).then(res => {
                setCurrentPage(1);
                setTotalProdutos(res.data.totalprodutos);
                if (res.data.totalprodutos == '0') {
                    setVisibilidade2(false);
                    setSemDados(true);
                    setTotalProdutos(1);
                }
            });
        }
    }, [search, utilizador, filtroCodigo, filtroUtilizador, filtroData, filtroNome, filtroValor, filtroDespesa.id ?? '', filtroEstado]);

    useEffect(() => {
        if (!utilizador) {
            return;
        }
        if (utilizadorEscolhido != '' || estadoEscolhido != '') {
            setSearch('');
            setVisibilidade2(true);
            let utilizadorF;
            let estadoF;
            if (utilizadorEscolhido == '') {
                utilizadorF = '';
            } else {
                utilizadorF = utilizadorEscolhido?.value;
            }
            if (estadoEscolhido == '') {
                estadoF = '';
            } else {
                estadoF = estadoEscolhido.value;
            }
            getDespesasFiltros(utilizador, utilizadorF, estadoF, 0, 14, lang).then(res => {
                HandleSpinner();
                // setDespesas(res.data.despesas);
                setCurrentPage(1);
                setTotalProdutos(res.data.totalprodutos);

                if (res.data.despesas.length == 0) {
                    setVisibilidade2(false);
                    setSemDados(true);
                    setTotalProdutos(1);
                }
            });
        }
    }, [utilizadorEscolhido, estadoEscolhido, utilizador]);

    useEffect(() => {
        if (despesas.length != 0 && semDadosEstado == false) {
            setVisibilidade(false);
            setSemDados(false);
            setVisibilidade2(false);
        } else if (despesas.length == 0 && semDadosEstado == true) {
            setVisibilidade(false);
            setVisibilidade2(false);
            setSemDadosArray(true);
            setTotalProdutos(1);
        }
    }, [despesas]);

    const despesasDados = useMemo(() => {
        let despesasInfo = despesas;

        setTotalItems(despesasInfo.length);
        if (sorting.field) {
            const reversed = sorting.order === 'asc' ? 1 : -1;
            despesasInfo = despesasInfo.sort((a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field]));
        }

        return despesasInfo;
    }, [despesas, currentPage, sorting]);

    function limparFiltros() {
        setUtilizadorEscolhido('');
        setEstadoEscolhido('');
        setCurrentPage(1);
        setVisibilidade2(true);
        setFiltroCodigo('');
        setFiltroData({
            startDate: '',
            endDate: '',
        });
        setFiltroDespesa('');
        setFiltroEstado(0);
        setFiltroNome('');
        setFiltroUtilizador([]);
        setFiltroValor();
        getDespesas(utilizador, 0, 14, lang, filtroCodigo, filtroUtilizador, filtroData.startDate, filtroNome, filtroValor, filtroDespesa.id ?? '', filtroEstado?.value ?? 0).then(res => {
            HandleSpinner();
            if (res.data.totalprodutos == '0') {
                setSemDadosEstado(true);
                setVisibilidade2(false);
            }
            setDespesas(res.data.despesas);
            setTotalProdutos(res.data.totalprodutos);
        });
    }

    useEffect(() => {
        if (despesasDados.length == 0 && loading == false) {
            setSemDados(true);
        } else {
            setSemDados(false);
        }
    }, [despesasDados]);
    return (
        <div>
            {isMobile || isCard ? (
                <div>
                    {despesasDados?.map((dados, index) => (
                        <div key={index} className={`rounded-none border border-l-0 border-r-0 border-t-0 border-neutral-200 bg-white dark:border-neutral-600 dark:bg-gray-800`}>
                            <h2 className="mb-0" id="headingOne">
                                <button
                                    className="group relative flex w-full font-medium items-center rounded-none border-0 bg-white px-5 py-1 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] dark:bg-gray-800 text-primary   dark:text-white "
                                    type="button"
                                    data-te-collapse-init
                                    data-te-collapse-collapsed
                                    data-te-target={'#flush-collapseThree' + index}
                                    aria-expanded="false"
                                    aria-controls="flush-collapseThree">
                                    <div className="flex flex-row" onClick={() => onRowClick(dados)}>
                                        {dados.id} - {dados.utilizador} - {dados.nome}
                                    </div>
                                    <span className="ml-auto h-5 w-5 shrink-0 rotate-[180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#075baf] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-6 w-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                        </svg>
                                    </span>
                                </button>
                            </h2>
                            <div
                                id={'flush-collapseThree' + index}
                                className={openCards ? 'visible' : '!visible hidden'}
                                data-te-collapse-item
                                aria-labelledby="flush-headingThree"
                                data-te-parent="#accordionFlushExample">
                                <div className="px-5 py-4">
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('data')}:</div> {dados.data}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('nome')}: </div> {dados.nome}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('valor')}: </div>{' '}
                                        <div className="text-blue-600 font-medium dark:text-blue-500">
                                            {formatarNumero(dados.valor)} {dados.simboloMoeda}
                                        </div>
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('tipoDespesa')}: </div> {dados.tipoDespesa}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('estado')}: </div> {dados.status}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    {loading && (
                        <div className="flex flex-row mt-14 justify-center">
                            <>
                                <Spinner />
                            </>
                        </div>
                    )}
                    <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                        <div>
                            <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalProdutos / ITEMS_PER_PAGE)}</span>
                            </span>

                            <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalProdutos}</span>
                            <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                        </div>
                        <TablePagination total={totalProdutos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                    </nav>
                </div>
            ) : (
                <div className="relative  overflow-x-auto shadow-md sm:rounded-[8px]">
                    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                            <tr>
                                <th scope="col" className="px-6 py-3">
                                    {t('codigo')}
                                    <InputFilter
                                        onSearch={value => {
                                            setFiltroCodigo(value);
                                            setCurrentPage(1);
                                        }}
                                    />
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    {t('utilizador')}
                                    <MultiSelect
                                        isMulti
                                        options={utilizadores}
                                        value={filtroUtilizador.label}
                                        onChange={e => {
                                            setFiltroUtilizador(e);
                                            setCurrentPage(1);
                                        }}
                                        noOptionsMessage={t('semopcoes')}
                                        placeholder={t('filtro')}
                                    />
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    {t('data')}
                                    <Datepicker
                                        displayFormat="DD/MM/YYYY"
                                        // maxDate={today}
                                        useRange={false}
                                        asSingle={true}
                                        value={filtroData}
                                        onChange={newValue => {
                                            setFiltroData(newValue);
                                            setCurrentPage(1);
                                        }}
                                        inputClassName={`rounded-[8px] w-full bg-gray-50 border border-gray-300 text-xs text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                                    />
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    {t('nome')}
                                    <InputFilter
                                        onSearch={value => {
                                            setFiltroNome(value);
                                            setCurrentPage(1);
                                        }}
                                    />
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    {t('valor')}
                                    <InputFilter
                                        onSearch={value => {
                                            setFiltroValor(value);
                                            setCurrentPage(1);
                                        }}
                                    />
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    {t('tipoDespesa')}
                                    <SelectFilter
                                        options={tipoDespesas}
                                        value={filtroDespesa ? filtroDespesa?.label : ''}
                                        onChange={e => {
                                            setFiltroDespesa({
                                                id: e?.value,
                                                tipo: e?.label,
                                            });
                                            setCurrentPage(1);
                                        }}
                                        noOptionsMessage={t('semopcoes')}
                                        placeholder={t('filtro')}
                                    />
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    {t('estado')}
                                    <div className="flex flex-row ">
                                        <SelectFilter
                                            options={estados}
                                            value={filtroEstado}
                                            onChange={e => {
                                                setFiltroEstado({
                                                    value: e?.value,
                                                    label: e?.label,
                                                });
                                                setCurrentPage(1);
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('filtro')}
                                        />
                                        {filtroDespesa != '' || (filtroEstado != 0 && filtroEstado != undefined) || filtroUtilizador.length != 0 ? (
                                            <button
                                                onClick={limparFiltros}
                                                type="button"
                                                className="flex items-center border-gray-300 text-gray-600 hover:text-blue-600 bg-gray-100 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[8px] ml-2 text-xs  text-center dark:bg-gray-600 dark:text-white dark:hover:text-blue-500 dark:focus:ring-blue-800">
                                                <FilterAltOffIcon />
                                            </button>
                                        ) : null}
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {despesasDados.map(dados => (
                                <tr
                                    key={dados.id}
                                    className="odd:bg-white even:bg-gray-100 odd:dark:bg-gray-700 hover:border-2 border-b cursor-pointer dark:bg-gray-800 dark:border-gray-600 hover:border-amber-400 hover:dark:border-amber-400 "
                                    onClick={() => handleRowClick(dados)}>
                                    <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                        {dados.id}
                                    </th>
                                    <td className="px-6 py-1">{dados.utilizador}</td>
                                    <td className="px-10 py-1">{dados.data}</td>
                                    <td className="px-6 py-1">{dados.nome}</td>
                                    <td className="flex px-6 py-1 justify-end text-blue-600 dark:text-blue-500">
                                        {formatarNumero(dados.valor)} {dados.simboloMoeda}
                                    </td>
                                    <td className="px-6 py-1">{dados.tipoDespesa}</td>
                                    <td className="px-6 py-1 ">{dados.status}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {semDados && !loading && <NotFound frase={t('semRegistos')} />}
                    {loading && (
                        <div className="flex flex-row mt-14 justify-center">
                            <>
                                <Spinner />
                            </>
                        </div>
                    )}

                    <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                        <div>
                            <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalProdutos / ITEMS_PER_PAGE)}</span>
                            </span>

                            <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalProdutos}</span>
                            <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                        </div>
                        {totalProdutos != 0 &&  <TablePagination total={totalProdutos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} /> }
                    </nav>
                </div>
            )}
        </div>
    );
}

export default Table;
